import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';
import { dispatch } from '../store';

const initialState = {
  isLoading: false,
  error: null,
  globalVariableList: null,
  globalVariable: null,
};

const slice = createSlice({
  name: 'globalVariable',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    getGlobalVariableListSuccess(state, action) {
      state.isLoading = false;
      state.globalVariableList = action.payload;
    },
    getGlobalVariableSuccess(state, action) {
      state.isLoading = false;
      state.globalVariable = action.payload;
    },
    createGlobalVariableSuccess(state, action) {
      state.isLoading = false;
      state.globalVariableList.push(action.payload);
    },
    updateGlobalVariableSuccess(state, action) {
      state.isLoading = false;
      const updated = action.payload;
      state.globalVariableList = state.globalVariableList.map((item) =>
        item._id === updated._id ? updated : item
      );
    },
    deleteGlobalVariableSuccess(state, action) {
      state.isLoading = false;
      state.globalVariableList = state.globalVariableList.filter((item) => item._id !== action.payload);
    },
  },
});

export default slice.reducer;

export function getGlobalVariable(id) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const url = `/api/admin/globalVariables/${id}`;
      const response = await axios.get(url);
        dispatch(slice.actions.getGlobalVariableSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getGlobalVariables() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const url = '/api/admin/globalVariables';
      const response = await axios.get(url);
      dispatch(slice.actions.getGlobalVariableListSuccess(response.data?.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function createGlobalVariable(data) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/api/admin/globalVariables', {data});
      dispatch(slice.actions.createGlobalVariableSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function updateGlobalVariable(id, data) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.put(`/api/admin/globalVariables/${id}`, {data});
      dispatch(slice.actions.updateGlobalVariableSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function deleteGlobalVariable(id) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.delete(`/api/admin/globalVariables/${id}`);
      dispatch(slice.actions.deleteGlobalVariableSuccess(id));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
